import { DRUGS, PROFANITY, SEX, VIOLENCE } from '@/assets/javascript/enums/advisors'

const icons = {
  '[18]': '<svg><use xlink:href="#icon-Y18"/></svg>',
  '[16]': '<svg><use xlink:href="#icon-Y16"/></svg>',
  '[12]': '<svg><use xlink:href="#icon-Y12"/></svg>',
  '[7]': '<svg><use xlink:href="#icon-Y7"/></svg>',
  '[0]': '<svg><use xlink:href="#icon-Y0"/></svg>',
  '[w]': '<svg><use xlink:href="#icon-vulgarism"/></svg>',
  '[n]': '<svg><use xlink:href="#icon-drugs"/></svg>',
  '[s]': '<svg><use xlink:href="#icon-sex"/></svg>',
  '[p]': '<svg><use xlink:href="#icon-violence"/></svg>'
}

const apiValuesToIcons = {
  [PROFANITY]: icons['[w]'],
  [DRUGS]: icons['[n]'],
  [SEX]: icons['[s]'],
  [VIOLENCE]: icons['[p]'],
  0: icons['[0]'],
  7: icons['[7]'],
  12: icons['[12]'],
  16: icons['[16]'],
  18: icons['[18]']
}

export default {
  computed: {
    advisorsFromApi () {
      if (!this.product?.advisors?.length) {
        return false
      }

      return `${apiValuesToIcons[this.product?.rating] || ''}${this.advisorIcons}`
    },
    advisorIcons () {
      return this.product.advisors?.map(({ name }) => apiValuesToIcons[name]).join('')
    },
    advisorsWithDescription () {
      return this.product.advisors?.map(({ name }) => ({
        icon: apiValuesToIcons[name],
        description: this.$t(`advisors.${name.toLowerCase()}`)
      }))
    }
  },
  methods: {
    advisors (value) {
      return value?.replace(/\[18]|\[w]|\[n]|\[s]|\[p]/gi, (matched) => icons[matched])
    },
    replaceAdvisors (value) {
      return value?.replace(/\[18]|\[w]|\[n]|\[s]|\[p]/gi, '')
    }
  }
}
